module.exports = __webpack_public_path__ + "img/l4.416ea2d2.png";